module.exports = __webpack_public_path__ + "img/Logo Acronyms_Blue_Circle.c63d8b7a.png";